import React, {useState, useEffect} from "react"
import {
    MDBContainer, MDBRow, MDBCol, MDBBtn, MDBDropdownItem, MDBCollapse, MDBAlert
} from 'mdbreact';
import classes from './Homepage.module.css'
import {Trans} from "react-i18next";
import NewPendingRequest from "./NewPendingRequest/NewPendingRequest";
import ShareContainer from "../../Component/ShareContainer/ShareContainer";
import logo from "../../Assets/logo.png";
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import {returnTran} from "../../Utils/Trans";

const Homepage = (props) => {

    return (
        <MDBContainer>
            <Helmet>
                <title> {'MeWeSearcher'}</title>
                {/*<meta property="fb:app_id" content="1293953327456577" />*/}
                <meta property="og:type" content="website"/>
                <meta property="site_name" content="MeWeSearcher"/>
                <meta property="title" content={'MeWeSearcher'}/>
                <meta name="description" content={returnTran("LeftNavBar", "description")}/>
                <meta name="keywords" content={"mewe, search mewe, 找尋mewe群組, 香港mewe"}/>
                <meta property="og:title"
                      content={'MeWeSearcher'}/>
                <meta property="og:description" content={returnTran("LeftNavBar", "description")}/>
                <meta property="og:url" content={"https://mewesearcher.com" + window.location.pathname}/>
                <meta property="og:site_name"
                      content={"MeWeSearcher | " + returnTran("LeftNavBar", "description")}/>
                {/*<meta property="og:updated_time"*/}
                {/*      content={new Date(this.state.article.lastModified.hasOwnProperty('seconds') ? this.state.article.lastModified.seconds * 1000 : this.state.article.lastModified._seconds * 1000 ).toISOString()}/>*/}
                <meta httpEquiv="content-language"
                      content={localStorage.getItem("i18n-lang") === "en" ? "en-us" : "zh-Hant"}/>
                <meta property="og:type" content="article"/>
                <meta property="og:image" content={"https://imgur.com/a/AMU0634"}/>
                <meta property="og:image:width" content="1280"/>
                <meta property="og:image:height" content="720"/>
                {/*<link rel="amphtml" href={"https://clipversity.com/amp/article/" + this.state.article.key}/>*/}
            </Helmet>
            <MDBRow>
                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <Link to={'/list'}>
                        <div className={classes.Recommended}>
                            <div className={classes.StartBtn}>
                                <Trans>Homepage.find-group-and-page</Trans>
                            </div>
                        </div>
                    </Link>
                </MDBCol>

                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">

                    {
                        window.location.href === "https://mewesearcher.web.app/" &&
                        <MDBAlert color={"info"} className={classes.Alert}>
                            <a href={'https://mewesearcher.com'}>
                                <Trans>Homepage.new-domain-alert</Trans>
                            </a>
                        </MDBAlert>
                    }

                        <MDBAlert color={"success"} className={classes.Alert}>
                            <Link to={'/newest'}>
                                <Trans>Homepage.newest-message</Trans>
                            </Link>
                        </MDBAlert>

                </MDBCol>

                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <NewPendingRequest/>
                </MDBCol>

                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <div className={classes.ShareContainer}>
                        <div>
                            <img src={logo} className={classes.Logo} alt={'mewe, search mewe page'}/>
                        </div>
                        <div>
                            <Trans>Homepage.share-msg</Trans>
                        </div>
                        <div>

                        </div>
                        <div>
                            <ShareContainer
                                url={"https://mewesearcher.com"}
                                img={"https://mewesearcher.web.app/logo512.png"}
                                title={"我要分享呢個MeWeSearcher比你"}
                                content={"比你搵到你想要嘅MeWe Page/Group"}
                                tags={[]}
                            />
                        </div>
                    </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>


            </MDBRow>
        </MDBContainer>
    )

}
export default Homepage

